import script from "./SpellingGame.vue?vue&type=script&setup=true&lang=js"
export * from "./SpellingGame.vue?vue&type=script&setup=true&lang=js"

import "./SpellingGame.vue?vue&type=style&index=0&id=3b486e0a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b486e0a"]])

export default __exports__